module.exports = __webpack_public_path__ + "img/DW365-225.db4bf3d2.jpg";